export const AlignJustifyStyle = {
    start: 'justify-start',
    center: 'justify-center',
    end: 'justify-end',
};
//# sourceMappingURL=AlignJustifyStyle.js.map